import { useLocation } from 'react-router-dom';

const useAdminBackPath = (defaultBack = '/admin', { overrideBack } = {}) => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const fromLocations = searchParams.get('from')?.split(',') || [];
  const fromId = searchParams.get('fromId');

  const params =
    fromLocations.length > 1 ? `?from=${fromLocations.slice(1).join(',')}` : ``;

  const getBackPath = () => {
    const routes = {
      analytics: '/admin',
      'payout-balance': '/admin/vendors/payout-balance',
      'escrow-balance': '/admin/stores/escrow-balance',
      vendors: '/vendor/vendors',
      stores: '/vendor/stores'
    };

    const path = routes[fromLocations[0]?.toLocaleLowerCase()];
    return overrideBack
      ? `${overrideBack}${params}`
      : path
      ? `${path}${fromId ? `/${fromId}` : ''}${params}`
      : defaultBack;
  };

  return { backPath: getBackPath(), params };
};

export { useAdminBackPath };
